<template>
  <div class="swiper-container">
    <img class="title" src="@/assets/images/hero/title.png" />
    <img class="players" src="@/assets/images/hero/players-2.png" />
    <img class="title mobile" src="@/assets/images/hero/title-mobile.png" />
    <img class="players mobile" src="@/assets/images/hero/players-mobile-2.png" />
  </div>
</template>

<script>
export default {
  name: "HeroSlider",
  data() {
    return {
      windowWidth: window.innerWidth,
    };
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
    },
  },
  computed: {
    isMobile() {
      return this.windowWidth <= 992;
    },
  },
};
</script>

<style lang="scss" scoped>
.swiper-container {
  width: 100%;
  aspect-ratio: 1728 / 1040;
  max-height: 1040px;
  margin-top: 77px;
  background: url('~@/assets/images/hero/bg-hero.jpg');
  background-size: cover;
  position: relative;

  @media screen and (max-width: $lg) {
    margin-top: 65px;
  }

  @media screen and (max-width: $md) {
    aspect-ratio: 430 / 812;
    max-height: none;
  }

  &::before {
    background-image: url('~@/assets/images/hero/long-glow-bar.png');
    background-position: 50%;
    bottom: -210px;
    content: "";
    height: 470px;
    left: 0;
    pointer-events: none;
    position: absolute;
    width: 100%;
    z-index: 2;
    background-size: contain;

    @media screen and (max-width: 1200px) {
      background-size: cover;
    }
  }

  .title {
    position: absolute;
    top: -54px;
    left: 50%;
    transform: translateX(calc(-53%));
    width: 95%;
    max-width: 1728px;

    @media screen and (max-width: 1600px) {
      top: 0;
    }

    @media screen and (max-width: $md) {
      display: none;
    }

    &.mobile {
      display: none;

      @media screen and (max-width: $md) {
        display: block;
        width: 100%;
        transform: translateX(-50%);
        top: -125px;
      }

      @media screen and (max-width: $sm) {
        top: -65px;
      }
    }
  }

  .players {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 95%;
    max-width: 1728px;

    @media screen and (max-width: $md) {
      display: none;
    }

    &.mobile {
      display: none;

      @media screen and (max-width: $md) {
        display: block;
        width: 100%;
      }
    }
  }
}
</style>
